/* eslint-disable */
import React, { useEffect, useState, FC, Fragment, useRef, memo } from 'react';

//Components//
import Header from 'Components/header';
import ProgressBar from 'Components/progressBar';
import { FormItem, FormGroup } from 'Components/helpers';
import SubmissionErrorMessage from 'Components/submissionErrorMessage';
import { StepAction } from 'Components/buttons/stepButton';

//Containers
import { FormFields } from 'Containers/formFields';
import StepButton from 'Containers/stepButton';

//Styles and animations//
import injectSheet from 'react-jss';
import classNames from 'classnames';
import { TweenMax } from 'gsap';
import moment from 'moment';

import { animate } from './animations';
//Analytics//
import Analytics from '@analytics/index';

//Utils//
import MobileDetect from 'Utils/mobileDetect';
import validate from 'Utils/inputValidations';
import { isIe11 } from 'Utils/browserDetect';
import { displayProgressBar } from 'Utils/uiOverrides';
import styleSheet from './styles';
import { areEqualObjects } from 'Utils/lodashUtils';
import { ITourInterface } from '@store/tour/types';
import { IYouVisitAnalytics } from '@store/youvisitAnalytics/types';
import useHeapTrack from '../../hooks/useHeapTrack';

// Constants //
import { DEFAULT_SUBMISSION_ERROR_MESSAGE } from '../../constants/errorConstants';
import FORM_STATE from '@src/constants/formStateConstants';

type FieldData = {
  value: string;
  isValidated: boolean;
  label: string;
  fieldId: string;
  inputType: string;
  disabled: boolean;
  required: boolean;
  errorMessage: string | null;
  defaultValue: string;
  sortOrder: string;
  compressHeight?: boolean;
  personalizationShown?: string;
  list: [];
  showBoolean: boolean;
  __typename: string;
};
interface Props {
  steps: Array<object>;
  currentStep: number;
  onClick?: () => void;
  classes?: any;
  formState: any;
  setCurrentStep?: (step: number, stepAction: StepAction) => void;
  setFormState?: (stepValues: Array<object>) => void;
  setErrorState?: (errorValues: Array<object>) => void;
  resetErrorState?: () => void;
  resetSharedFormValues?: () => void;
  enableStepProgression?: () => void;
  disableStepProgression?: () => void;
  addCollegePill: (pill: any) => void;
  completed?: boolean;
  large_form_image?: string;
  title?: string;
  subtitle?: string;
  setCompleted?: (stepAction: StepAction) => void;
  stepRequiresGDPRValidation?: any;
  numberOfSkippedSteps?: number;
  tour: ITourInterface;
  analyticsData: IYouVisitAnalytics;
  mutate?: (variables: any) => Promise<any>;
  terminateSession: (errorMessage: string) => void;
  //----new
  stepInputState: object;
  setStepInputState: (data: object) => void;
  calcProgresspercentage: (
    currentStep: number,
    numberofSteps: number
  ) => number;
  hideNextButton: (fields: any[]) => Boolean;
  checkedCompliance: boolean;
  mapFieldIds: (fieldKey: string) => string;
  constrainList: (item: any) => any;
  collegePills: string[];
  personalizationCompleted: boolean;
}

const StepDisplay: FC<Props> = memo(
  ({
    classes,
    steps,
    currentStep = 0,
    onClick,
    setCurrentStep,
    setFormState,
    formState,
    setErrorState,
    resetErrorState,
    resetSharedFormValues,
    enableStepProgression,
    disableStepProgression,
    addCollegePill,
    completed,
    large_form_image,
    title,
    subtitle,
    setCompleted,
    stepRequiresGDPRValidation,
    tour,
    analyticsData,
    mutate,
    stepInputState,
    setStepInputState,
    calcProgresspercentage,
    hideNextButton,
    checkedCompliance,
    mapFieldIds,
    constrainList,
    terminateSession,
    collegePills,
    personalizationCompleted,
  }: Props) => {
    useHeapTrack('cif_form_viewed');
    const currentStepId = steps[currentStep]['stepId'];
    const fields = steps[currentStep]['fields'];
    const fieldIDs = fields.map((f: any) => f.fieldId);
    const isYVCOM = analyticsData.analytics.source == 'yvcom';
    const parentErrorMessage =
      'While your child is not old enough to register yet, we hope you enjoy this immersive experience.';
    const ownErrorMessage =
      'While you are not old enough to register yet, we hope you enjoy this immersive experience.';

    const [submissionError, setSubmissionError] = useState(null);
    const [stepCounter, setStepCounter] = useState(0);
    const [personalizationPillsShown, setPersonalizationPillsShown] = useState(
      false
    );

    const handlePersonalizationToggle = () => {
      setPersonalizationPillsShown(prevShown => !prevShown);
    };

    let formHolder: any = null;
    let sub: any = null;
    let stepImageHolder: any = null;

    // Get current image and animation resources.  Get metadata assocaited with header image
    // to determine what to display
    // Skip visitor type steps
    const displayProgressBarBoolean = displayProgressBar(currentStepId);
    // Upper bound sets up range so message doesn't keep getting displayed every time a step is shown
    // Formula of x + 100/steps.length where x is the percent value should ensure it's only shown for 1 step
    const progressBarMessages = [
      {
        percentage: ((steps.length - 1) / steps.length) * 100,
        message: 'Almost done!',
      },
    ];

    // form references //
    //Setting up useRef likes this, gets rid of the warning, Oject is possible undefined.
    const formRef = useRef<HTMLDivElement>();
    let wrapper = useRef<HTMLDivElement>();

    //For grouping fields based on sortOrder//
    let group: any = []; //Injects coupled groups such as First and Last Name into its own array to render rows. This allows coupled fields on a single row

    let fieldCountIndex = 0; //Creates an index for each form field as they render. This is used to animate in sequence and create key for loops

    let fieldDataGrouped: any = []; //An array that holds all fields now coupled and ready to render. Every array in fieldDataGrouped is a form field, arrays with more than one value are coupled fields
    //end For grouping fields based on sortOrder//

    //Error handling
    const animateError = (error: string) => {
      let domErrorElement =
        wrapper.current?.querySelector(`[name="${error}"]`) ||
        wrapper.current?.querySelector(`[data-name="${error}"]`) ||
        wrapper.current?.querySelector(`[id="${error}"]`);
      if (domErrorElement) {
        animate.pulse(domErrorElement);
      }
    };

    // mounted is used to know when to use componentDidMount lifeCycle//
    const mounted: any = useRef();

    useEffect(() => {
      let delay = 0;

      if (!mounted.current && wrapper.current) {
        /*
        todo update these items with refs 
        form Container, next button and stepImage
      */
        formHolder = wrapper.current.children[0].children[1]; // form container //
        sub = wrapper.current.children[1]; // Submit / Next button //
        stepImageHolder = wrapper.current.children[0].children[0]; // stepimage //

        const stepData = JSON.stringify({
          currentStep: currentStep + 1,
          stepId: currentStepId,
          totalSteps: steps.length,
        });
        let postMessage = `data:::stepData:::${stepData}`;
        if (personalizationCompleted) {
          postMessage += `:::personalization`;
        }
        window.parent.postMessage(postMessage, '*');

        //Stop flickering when loads in//
        TweenMax.set([wrapper.current, formHolder, sub, stepImageHolder], {
          opacity: 1,
        });

        //reset inputs//
        const allFormItems = wrapper.current.children[0].children[1];

        const inputs: string | any[] | NodeListOf<Element> = allFormItems
          ? allFormItems.querySelectorAll('input,button,select')
          : [];

        //TODO Refactor//
        //if step only has one label, it makes it larger to make it feel like a title, as per design//
        let labelCount = 0;
        const labels = allFormItems.querySelectorAll('label');
        if (labels) {
          labels.forEach((item: any) => {
            if (item.textContent.length > 1) labelCount++;
          });
        }

        if (labelCount === 1 && MobileDetect.phone()) {
          const style = 'font-size:24px;margin-bottom:24px';
          labels.forEach((item: any) => {
            const style = item.style;
            style.fontSize = style.marginBottom = '24px';
          });
        }

        //set focus to first field item only if it is not a button and after the vistor types screens//
        if (inputs[0] && inputs[0].tagName !== 'BUTTON' && currentStepId >= 0) {
          inputs[0].setAttribute('autofocus', 'autofocus');
          inputs[0].focus();
        }

        //Intro animations//
        let form = wrapper.current.children[0]; // Form fields //

        //ToDo:  How can I get out of looping twice.
        for (let i = 0; i < form.children.length; i++) {
          const item = form.children[i];
          if (item.children.length > 0) {
            for (let j = 0; j < item.children.length; j++) {
              delay++;
              const field = item.children[j];
              animate.in(field, delay);
            }
          } else {
            animate.in(item, delay);
          }
        }
        delay++;

        if (sub) animate.in(sub, delay);

        mounted.current = true;
      }
      // Works as a debounce for allowing progression to the next step
      TweenMax.delayedCall(delay / 5 + 0.5, () => {
        enableStepProgression();
      });
      //end intro animation//
    }, [currentStep, mounted.current]);

    //Find couples and put into groups//
    // NEED TO ADD COMMENT HERE EXPLAINING DECIMAL SYSTEM
    fields.forEach((item: FieldData, index: number) => {
      let isNextAttached = false;
      //check if next field is on the same line//
      const itemSortOrderFloat = parseFloat(item.sortOrder);
      if (fields.length > 1) {
        let nextItem: FieldData = fields[index + 1];
        if (nextItem) {
          const nextItemSortOrderFloat = parseFloat(nextItem.sortOrder);
          // If there is a decimal
          if ((isNextAttached = nextItemSortOrderFloat % 1 !== 0)) {
            // See if decimal value same as prior sort order value in the tenths place, meaning it's on the same line
            isNextAttached =
              //@ts-ignore//
              parseInt(itemSortOrderFloat * 10) ==
              //@ts-ignore//
              parseInt(nextItemSortOrderFloat * 10)
                ? true
                : false;
          }
        }
      }

      // Group data if there is a decimal value
      if (isNextAttached || itemSortOrderFloat % 0 !== 0) {
        group.push(item);
        // if a group is last or if the next field isnt part of the group then push it to fieldDataGrouped and reset group//
        if (
          (index + 1 === fields.length && !isNextAttached) ||
          !isNextAttached
        ) {
          fieldDataGrouped.push(group);
          group = [];
        }
      } else {
        //group set ended so push and wipe//
        if (group.length > 0) {
          fieldDataGrouped.push(group);
        }
        group = [];
        //push single item//
        fieldDataGrouped.push([item]);
      }
    });
    //end field couples//

    //@ts-ignore
    let hideNext = hideNextButton(steps[currentStep].fields);

    const checkFields = () => {
      //Initialize stepvalues array to be passed to store
      const errorValues: Array<object> = [];
      if (resetErrorState) resetErrorState();
      //loop Through all form fields and check they are validated
      formRef?.current['props']?.children?.forEach((holder: any) => {
        holder.forEach((field: any) => {
          // if show showBoolean is false, it renders a null value, so we dont need to include those in our loop//
          // Short circuiting for visitor type field because use of field.props results in race condition that invalidates
          // button on initial click.  Need to fix bug
          if (field && field.props.fieldData.fieldId !== 'visitortype') {
            // Force postal to not be required if country code is not North America //
            if (field.props.fieldData.fieldId === 'postal') {
              field.props.fieldData.required =
                stepInputState['country'] === 'USA' ||
                stepInputState['country'] === 'CAN';
            }
            if (
              field.props.fieldData.hasError &&
              (field.props.fieldData.required ||
                (field.props.fieldData.value &&
                  field.props.fieldData.value.length > 0))
            ) {
              //Push error
              errorValues.push({
                [field.props.fieldData.fieldId]: true,
              });
              // //Set error in store
              setErrorState(errorValues);
              // //Animate error field
              animateError(field.props.fieldData.fieldId);
            }
          }
        });
      });
      return errorValues.length === 0;
    };

    // Sets error on gdpr compliance checkbox
    const multiDomSelections = () => {
      wrapper.current
        .querySelectorAll('[id="checkbox"], [id="gdpr-error-text-container"]')
        .forEach((element: any, i: number) => {
          //By looking at the selector we can apply the proper element to animate
          switch (i) {
            case 0:
            case 1:
              animate.red(element);
              break;
            case 2:
              element.textContent = 'PLEASE CHECK BOX TO CONTINUE';
              break;
            default:
              break;
          }
        });
    };

    const handleChange = (e: any) => {
      if (tour.mode === 'preview') return;

      setSubmissionError(null);
      if (e.target.fieldId === 'visitortype') {
        reportVisitorClicked_analytics(e.target.value);
      }

      if (e.target.fieldId === 'schools_interested') {
        addCollegePill({ value: e.target.value, label: e.target.label });
      }

      multiDomSelections();
      // Checks to see whether we're validating on next button click
      // If not, run validation code on change
      //@ts-ignore
      if (hideNextButton(steps[currentStep].fields)) {
        //Initialize stepvalues array to be passed to store
        if (stepRequiresGDPRValidation) {
          setStepInputState({ [e.target.fieldId]: e.target.value });

          if (e.target.fieldId === 'visitortype') {
            if (checkedCompliance) {
              proceedToNextStep('button_clicked');
            } else {
              // Send analytics event showing that start was clicked without agreeing
              startClickedWithoutAgreeing_analytics();
              // Display error on checkbox
              multiDomSelections();
            }
          }
        } else
          storeData(
            [
              {
                [e.target.fieldId]: e.target.value,
              },
            ],
            'button_clicked'
          );
      } else {
        setStepInputState({ [e.target.fieldId]: e.target.value });
      }
    };

    const collectValues = () => {
      //Initialize stepvalues array to be passed to store
      let stepValues: Array<object> = [];

      //loop Through all form fields and collect values
      formRef?.current['props']?.children.forEach((holder: any) => {
        holder.forEach((field: any) => {
          //if show showBoolean is false, it renders a null value, so we dont need to include those in our loop//
          if (field && field.props.fieldData.inputType !== 'label') {
            let value = stepInputState[field.props.fieldData.fieldId];
            if (field.props.fieldData.fieldId === 'birthdate')
              value = moment(value).format('MM/DD/YYYY');
            if (field.props.fieldData.fieldId === 'schools_interested')
              value = collegePills?.map((pill: any) => pill.value).join(',');
            if (field.props.fieldData.fieldId === 'ethnicity_consent') {
              // want to set ethnicity to empty string if user does not consent
              if (!field.props.fieldData.value) {
                stepValues.forEach((field: any) => {
                  if (field['ethnicity']) field['ethnicity'] = '';
                });
              }
            }
            // checks for personalization fields, only want to send 1 set of personalization values depending on which field is shown
            if (
              field.props.fieldData.fieldId ===
              FORM_STATE.personalizationPreferences
            )
              value = personalizationPillsShown
                ? ''
                : field.props.fieldData.value;
            if (
              field.props.fieldData.fieldId ===
              FORM_STATE.personalizationSuggestions
            )
              value = personalizationPillsShown
                ? field.props.fieldData.value
                : '';

            stepValues.push({
              [field.props.fieldData.fieldId]: value,
            });
          }
        });
      });
      return stepValues;
    };

    const proceedToNextStep = (stepAction: StepAction) => {
      setSubmissionError(null);
      if (checkFields()) {
        disableStepProgression();
        let collectedValues = collectValues();

        // Validate age and terminate session //
        let dob = collectedValues.find((value: any) => value.birthdate);
        if (dob && !validate.age(dob['birthdate'])) {
          let errorMessage = formState?.visitortype?.includes('parent')
            ? parentErrorMessage
            : ownErrorMessage;
          terminateSession(errorMessage);
          setCompleted(stepAction);
        } else {
          storeData(collectedValues, stepAction);
        }
      }
    };

    //Todo:  Rewrite this, when I use the new Apollo setup
    const getMutationVariables = (stepValues: Array<object>) => {
      return {
        currentStep: currentStep,
        instId: tour.instId,
        locId: tour.locId,
        tourid: tour.tourid,
        source: analyticsData.analytics.source,
        originalSource: analyticsData.analytics.originalSource,

        userkey: analyticsData.analytics.userkey,
        sessionid: analyticsData.analytics.sessionId,

        onCampus: tour.oncampus,
        testing: tour.testing,

        embedType: tour.embedType,
        module_id: analyticsData.analytics.module,
        fieldData: stepValues.map(step => {
          let key = Object.keys(step)[0];
          return {
            // See explanation for mapFieldIds call above
            fieldID: mapFieldIds(key),
            value: step[key],
          };
        }),
        //@ts-ignore//
        lastCompletedStep: steps[currentStep].stepId,
        completed: currentStep + 1 === steps.length,
      };
    };

    //Todo:  This needs to be done the React way, with onChange events for the actual controls. Not mining the dom.
    const storeData = async (
      stepValues: Array<object>,
      stepAction: StepAction
    ) => {
      // @todo update these items with refs //
      formHolder = wrapper.current?.children[0]?.children[1];
      //TODO:  Can I use a useEffect to set these globally?
      sub = wrapper.current?.children[1]; // Submit / Next button //
      stepImageHolder = wrapper.current?.children[0]?.children[0];

      /**
       * Send Mutation to Backend for storage
       */
      let response;
      const isPersonalizedField = stepValues.some(
        step =>
          step.hasOwnProperty(FORM_STATE.personalizationPreferences) ||
          step.hasOwnProperty(FORM_STATE.personalizationSuggestions)
      );
      const skipMutation = isPersonalizedField && personalizationCompleted;
      // want to skip mutation if personalization fields are shown and already completed to avoid backend error
      if (!skipMutation) {
        try {
          response = await mutate(getMutationVariables(stepValues));
        } catch (e) {
          setSubmissionError(e.message || DEFAULT_SUBMISSION_ERROR_MESSAGE);
          enableStepProgression();
          return;
        }
      }
      const submissionResult = response?.data?.formDataSubmissionMutation;
      if (submissionResult?.status || skipMutation) {
        // status is true when there's no validation error in the backend.

        // add State (location) to formState //
        if (submissionResult?.data.ctx?.state)
          stepValues.push({ ['state']: submissionResult.data.ctx.state });

        // if user is in CA //
        if (submissionResult?.data.ctx?.state === 'CA') {
          // check if user is under 13 years of age
          const age =
            formState.birthdate && validate.getAge(formState.birthdate);
          // check if user has GPC enabled //
          const GPC = window.navigator['globalPrivacyControl'];

          if (age < 13) {
            // CA users 13 - 16 now allowed to proceed
            let errorMessage = formState?.visitortype?.includes('parent')
              ? parentErrorMessage
              : ownErrorMessage;
            terminateSession(errorMessage);
            setCompleted(stepAction);
          }
          if (GPC) {
            let instName = formState?.institution_name;
            terminateSession(
              `If you want ${instName} to know you are interested, please update your GPC setting`
            );
            setCompleted(stepAction);
          }
        }

        //animate step out//
        if (currentStep + 1 === steps.length) {
          TweenMax.to(wrapper.current, 0.1, {
            opacity: 0,
          });
        } else {
          // last step so animate all elements including progress bar//
          TweenMax.to([formHolder, sub, stepImageHolder], 0.1, {
            opacity: 0,
          });
        }

        TweenMax.delayedCall(0.1, function() {
          if (currentStep + 1 === steps.length) {
            if (setFormState) setFormState(stepValues);
            const stepData = JSON.stringify({
              currentStep: currentStep + 1,
              stepId: currentStepId,
              totalSteps: steps.length,
            });
            let postMessage = `data:::stepData:::${stepData}`;
            if (isPersonalizedField) {
              postMessage += `:::personalization`;
            }
            window.parent.postMessage(postMessage, '*');
            // Set completed to store
            if (setCompleted) setCompleted(stepAction);
          } else {
            if (resetErrorState) resetErrorState();
            // if (resetSharedFormValues) resetSharedFormValues();
            if (setFormState) setFormState(stepValues);
            setStepCounter(stepCounter + 1);
            if (setCurrentStep) setCurrentStep(currentStep + 1, stepAction);
            mounted.current = false;
            if (onClick) onClick();
          }
        });
      } else {
        // validation error from backend is in submissionResult.data
        const errorData = submissionResult?.data;
        if (errorData) {
          // display error under each input field
          const errorValues = Object.keys(errorData).map(key => ({
            [key]: errorData[key],
          }));
          setErrorState(errorValues);

          // display error message for the form
          const errorMessage = Object.keys(errorData).map(key => {
            return `${errorData[key]}\n`;
          });
          setSubmissionError(
            errorMessage.length > 0
              ? errorMessage
              : DEFAULT_SUBMISSION_ERROR_MESSAGE
          );
        } else {
          // backend returns false status, but no error data available.
          // So, display default error
          setSubmissionError(DEFAULT_SUBMISSION_ERROR_MESSAGE);
        }
        enableStepProgression();
      }
    };

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // ANALYTICS ACTIONS
    // https://stackoverflow.com/a/53121021/2152944

    // Default analytics data
    Analytics.EventAnalytics.setDefaultProperties({
      institution: '',
      inst_id: tour.instId,
      loc_id: tour.locId,
      tour_id: tour.tourid,
      source: analyticsData.analytics.source,
      userkey: analyticsData.analytics.userkey,
      container_type: 'conversational inquiry form',
    });

    // Dispatches only once, when container is initialized
    useEffect(() => {
      window.parent.postMessage('cif:RegistrationForm_Ready', '*');
      Analytics.EventAnalytics.track('registration_started', {});
    }, []);

    // Dispatches when new page is viewed
    useEffect(() => {
      Analytics.EventAnalytics.track('page_viewed', {
        page_index: currentStepId,
      });
    }, [currentStep]);

    // Dispatches message when visitor button clicked
    const reportVisitorClicked_analytics = (visitor_type: string) => {
      Analytics.EventAnalytics.track('visitor_clicked', {
        page_index: currentStepId,
        visitor_type,
      });
    };

    // Dispatches message when start clicked without
    const startClickedWithoutAgreeing_analytics = () => {
      Analytics.EventAnalytics.track('start_without_agreeing', {
        pageIndex: currentStepId,
      });
    };

    const caliPrivacyNotice = () => {
      return (
        <a
          style={{
            textDecoration: 'underline',
            color: '-webkit-link',
          }}
          href="https://eab.com/privacy-policy/ccpa-resident-notice/"
          target="_blank"
        >
          Do Not Sell or Share My Personal Information
        </a>
      );
    };

    const generatePrivacyFooterText = () => {
      if (tour.requiresGDPRCompliance && currentStep === 0) {
        return null;
      }

      // Return entire text if we're on the first step and not resuming
      if (!tour.lastCompletedStep && currentStep === 0) {
        return (
          <div>
            By clicking a button above you are agreeing to the{' '}
            <a
              href="https://www.youvisit.com/terms-of-use/"
              target="_blank"
              style={{ fontSize: '11pt' }}
            >
              YouVisit Terms of Use
            </a>{' '}
            and{' '}
            <a
              href="https://www.youvisit.com/privacy-policy/"
              target="_blank"
              style={{ fontSize: '11pt' }}
            >
              Privacy Policy
            </a>
            .
          </div>
        );
      } else {
        return (
          <div>
            <a
              href="https://www.youvisit.com/terms-of-use/"
              target="_blank"
              style={{ fontSize: '11pt' }}
            >
              YouVisit Terms of Use
            </a>{' '}
            and{' '}
            <a
              href="https://www.youvisit.com/privacy-policy/"
              target="_blank"
              style={{ fontSize: '11pt' }}
            >
              Privacy Policy
            </a>
          </div>
        );
      }
    };

    const handleCloseButton = () => {
      const closeData = JSON.stringify({
        isComplete: completed,
      });
      // pass data to SS and close iframe //
      window.parent.postMessage(
        `data:::closeHoverWithData:::${closeData}`,
        '*'
      );
    };

    const handleBackButton = (stepAction: StepAction) => {
      mounted.current = false;
      TweenMax.to(wrapper.current, 0.1, {
        opacity: 0,
        onComplete: () => {
          if (setCurrentStep) {
            setCurrentStep(currentStep - 1, stepAction);
            setStepCounter(stepCounter - 1);
          }
        },
      });
    };

    const nextStepButtonText = () => {
      if (currentStep === steps.length - 1) {
        return 'Done';
      } else if (tour.fromSearch) {
        return 'Enter';
      } else {
        return 'Next';
      }
    };

    let showBackButton = stepCounter > 0;

    return (
      <Fragment>
        {tour.isHover === '1' && (
          <button onClick={handleCloseButton} className={classes.closeButton}>
            <img src="images/UI/close.svg" />
          </button>
        )}
        {showBackButton && (
          <button
            tabIndex={0}
            aria-label={'Navigate Back'}
            onClick={handleBackButton}
            className={classes.backButton}
          >
            <img aria-hidden="true" src="images/UI/downarrow.svg" />
          </button>
        )}
        <div
          className={classes.progressBarHolder}
          style={{ display: displayProgressBarBoolean ? 'block' : 'none' }}
        >
          <div className={classes.progressBarCenter}>
            <ProgressBar
              currentStep={currentStep}
              isVisible={displayProgressBarBoolean}
              //completePercentage={completePercentage}
              completePercentage={calcProgresspercentage(
                currentStep,
                steps.length
              )}
              messages={progressBarMessages}
            />
          </div>
        </div>
        <div
          className={classNames({
            [classes.centerForm]: !MobileDetect.phone(),
          })}
        >
          <div
            ref={wrapper}
            className={classNames(classes.formWrapper, {
              [classes.visitorsMaxWidth]: !displayProgressBarBoolean,
            })}
          >
            <div
              style={{
                textAlign: 'center',
                marginBottom: MobileDetect.phone() ? '15px' : '0',
              }}
            >
              <Header
                currentStep={currentStep}
                // Hack if YVCOM source do not pass fieldIDs (ie do not render header images)
                fieldIDs={isYVCOM ? [] : fieldIDs}
                currentStepId={currentStepId}
                formTitle={title}
                formSubTitle={subtitle}
                logo={large_form_image}
              />
              <FormGroup ref={formRef}>
                {fieldDataGrouped.map(
                  (itemArray: Array<FieldData>, _index: number) => {
                    const spacer =
                      100 / itemArray.filter(item => item.showBoolean).length;
                    return itemArray.map((item: FieldData, index: number) => {
                      fieldCountIndex++;
                      return item.showBoolean ? (
                        <FormFields
                          collectValues={collectValues}
                          key={fieldCountIndex}
                          index={fieldCountIndex}
                          fieldData={constrainList(item)}
                          locId={tour.locId}
                          compressHeight={item.compressHeight}
                          width={spacer}
                          onChange={(e: any) => handleChange(e)}
                          personalizationPillsShown={personalizationPillsShown}
                          handlePersonalizationShown={
                            handlePersonalizationToggle
                          }
                          currentStepId={currentStepId}
                          stepInputState={stepInputState}
                          personalizationCompleted={personalizationCompleted}
                        />
                      ) : null;
                    });
                  }
                )}
              </FormGroup>
              {tour.requiresGDPRCompliance && currentStep === 0 && (
                <div
                  className={classes.gdprErrorTextContainer}
                  id={'gdpr-error-text-container'}
                ></div>
              )}
            </div>

            {submissionError !== null && (
              <SubmissionErrorMessage
                text={
                  submissionError === ''
                    ? DEFAULT_SUBMISSION_ERROR_MESSAGE
                    : submissionError
                }
              />
            )}

            <div>
              {!hideNext && (
                <FormItem>
                  <StepButton onAction={proceedToNextStep}>
                    {nextStepButtonText()}
                  </StepButton>
                </FormItem>
              )}
            </div>

            <div style={{ marginBottom: '20px' }}>
              <div className={classNames(classes.footerText)}>
                {generatePrivacyFooterText()}
                {caliPrivacyNotice()}
              </div>
            </div>
          </div>
        </div>
        <div
          className={classNames(classes.poweredByContainer, {
            [classes.poweredByContainerFirstStep]: !displayProgressBarBoolean,
          })}
        >
          Powered by{' '}
          {tour.typeid === 'college' ||
          tour.typeid === 'k12' ||
          tour.platform === 'yvcom' ? ( //college search platform should always return typeid of college
            <img src="images/appily_logo.svg" className={classes.appilyLogo} />
          ) : (
            <span className={classNames(classes.youvisitText)}>YouVisit</span>
          )}
        </div>
      </Fragment>
    );
  },
  areEqualObjects
);

export default injectSheet(styleSheet)(StepDisplay);
